import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {ButtonModule} from "primeng/button";
import {Router, RouterLink} from "@angular/router";
import {ImageModule} from "primeng/image";
import {PageNavigationBarComponent} from "../page-navigation-bar/page-navigation-bar.component";
import {SimpleResponsiveFrameComponent} from "../simple-responsive-frame/simple-responsive-frame.component";
import {CarouselModule} from "primeng/carousel";
import {TagModule} from "primeng/tag";
import {DialogModule} from "primeng/dialog";
import {DropdownModule} from "primeng/dropdown";
import {FormBuilder, FormsModule} from "@angular/forms";
import {InputNumberModule} from "primeng/inputnumber";
import {SliderModule} from "primeng/slider";
import {CatalogService} from "../../../services/catalog.service";
import {SegmentService} from "../../../services/segment.service";
import {SearchCriteriaSubject} from "../../../subject/search-criteria.subject";
import {SegmentInformationDto} from "../../../dto/segment.information.dto";
import {FiltersComponent} from "../filters/filters.component";
import {AdService} from "../../../services/ad.service";
import {AdInformationDto} from "../../../dto/ad.information.dto";
import {OptionResponseDto} from "../../../dto/option.reponse.dto";
import {SelectItem} from "primeng/api";
import {CityService} from "../../../services/city.service";

@Component({
  selector: 'app-menu-property',
  standalone: true,
    imports: [
        ButtonModule,
        RouterLink,
        ImageModule,
        PageNavigationBarComponent,
        SimpleResponsiveFrameComponent,
        CarouselModule,
        TagModule,
        DialogModule,
        DropdownModule,
        FormsModule,
        InputNumberModule,
        SliderModule,
        FiltersComponent
    ],
  templateUrl: './menu-property.component.html',
  styleUrls: ['./menu-property.component.scss']
})
export class MenuPropertyComponent implements OnInit {
    @Output() segmentChanged = new EventEmitter<number>();
    @Output() toggleFiltersEvent = new EventEmitter<void>();
    segments: SegmentInformationDto[] = [];
    loading = false;
    selectedSegmentId: any | null = null;
    showFilters: boolean = false; // Estado inicial de visibilidad de filtros
    segmentId: number = 1; // Segmento predeterminado
    offers: AdInformationDto[] = [];
    private actions: { [key: string]: string } = {
        'SALE': '#006699',
        'RENT': '#FFD680',
        'LEASING': '#B4C68C',
        'BANK_AUCTION': '#F5947A',
    };
    selectedOfferId: any | null = null;
    departments: OptionResponseDto[] = [];
    selectedDepartment: any = null;
    city: SelectItem[] = [];
    selectedCity: any = null;
    loadCityList: boolean = true;
    private imageMap: { [key: string]: string } = {
        'LPZ': 'assets/layout/images/home/cities/LP.png',
        'SCZ': 'assets/layout/images/home/cities/SC.png',
        'CBBA': 'assets/layout/images/home/cities/CBBA.png',
        'TJA': 'assets/layout/images/home/cities/TR.png',
        'OR': 'assets/layout/images/home/cities/OR.png'
    };

    constructor(private catalogService: CatalogService,
                private router: Router,
                private formBuilder: FormBuilder,
                private segmentService: SegmentService,
                private adService: AdService,
                private searchCriteriaSubject: SearchCriteriaSubject,
                private cityService: CityService,) {
    }

    ngOnInit(): void {
        this.loadSegments();
        this.loadOffers();
        this.loadDepartments();
    }

    loadSegments(): void {
        this.segmentService.getSegmentList().subscribe(
            (data) => {
                this.segments = data;
                this.loading = true;
                console.log('Segmentos cargados:', data);  // Agrega esta línea para depuración
            },
            (error) => console.error('Error al cargar segmentos:', error)
        );
    }
    onSegmentSelect(segmentId: number): void {
        this.selectedSegmentId = segmentId;
        this.segmentChanged.emit(this.selectedSegmentId);
        this.searchCriteriaSubject.setSearchCriteria({ segmentId });  // Enviar cambio globalmente
    }

    toggleFilters(): void {
        this.toggleFiltersEvent.emit();
    }
    loadOffers(): void {
        this.adService.getOffersList(this.segmentId).subscribe(
            (data: AdInformationDto[]) => {
                this.offers = data
                    .map((option: AdInformationDto) => ({
                        ...option,
                        color: this.actions[option.adCode] || null  // Asigna null si no existe la imagen
                    }))
                console.log('Ofertas cargadas:', data);  // Agrega esta línea para depuración
            },
            (error) => console.error('Error al cargar ofertas:', error)
        );
    }
    selectOffer(offerId: any): void {
        this.selectedOfferId = offerId;
    }
    private loadDepartments(): void {
        this.catalogService.getCatalogList('CT_DEPARTMENT').subscribe(
            (options: OptionResponseDto[]) => {  // Especificamos el tipo de options
                console.log('Opciones obtenidas del backend:', options); // Debug

                // Filtramos y asignamos solo los departamentos que tienen una imagen en imageMap
                this.departments = options
                    .map((option: OptionResponseDto) => ({
                        ...option,
                        image: this.imageMap[option.optionCode] || null  // Asigna null si no existe la imagen
                    }))
                    .filter(department => department.image !== null); // Solo incluimos los que tienen imagen

                console.log('Departamentos cargados con imagen:', this.departments); // Debug
            },
            (error) => {
                console.error('Error al cargar los departamentos:', error);
            }
        );
    }


    loadCities(departmentCode: string): void {
        this.city = [];
        this.cityService.getDepartmentCityList(departmentCode).subscribe(
            (options) => {
                console.log('Ciudades cargados: ', options); // Para depuración
                if (Array.isArray(options)) {  // Verifica que options sea un array
                    this.loadCityList = false;
                    this.city = options.map((option) => ({
                        label: option.cityName, // Ajusta según la estructura de `option`
                        value: option.cityId
                    }));
                } else {
                    console.error('Error: Se esperaba un array, pero se recibió: ', options);
                }
            },
            (error) => console.error('Error al cargar ciudades:', error)
        );
    }
    // Método al seleccionar un departamento
    onDepartmentSelect(departmentCode: any): void {
        this.selectedDepartment = departmentCode.value;
        console.log('Departamento seleccionado:', this.selectedDepartment);
        this.loadCities(this.selectedDepartment);
    }

    onCityChange(event: any): void {
        this.selectedCity = event.value;
        console.log('Ciudad seleccionada:', this.selectedCity);
    }
}
